module.exports = __webpack_public_path__ + "img/sign-safe.408b3fb9.svg";